// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".eopoi-widget .tour_best_season__wrapper .months{width:100%}.eopoi-widget .tour_best_season__wrapper .months .month{padding:1em 0 1em 0;width:16%}@media only screen and (min-width:800px){.eopoi-widget .tour_best_season__wrapper .months .month{width:8%}}.eopoi-widget .tour_best_season__wrapper .months .month.bg-main-mystic{font-weight:700}", ""]);
// Exports
module.exports = exports;
